import React, { useState } from 'react';
import AdminService from '../../../API/AdminService';
import styles from './Forum.module.css';
import logger from '../../../utils/logger';
const CreateTopicModal = ({ categories, onClose, onTopicCreated, editTopic = null }) => {
    const [formData, setFormData] = useState({
        title: editTopic?.title || '',
        content: editTopic?.content || '',
        category_id: editTopic?.category_id || ''
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Очищаем ошибки при изменении полей
        if (errors.length > 0) {
            setErrors([]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Валидация
        const validationErrors = AdminService.validateTopicData(formData);
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            setLoading(true);
            if (editTopic) {
                await AdminService.updateForumTopic(editTopic.id, formData);
            } else {
                await AdminService.createForumTopic(formData);
            }
            onTopicCreated();
        } catch (error) {
            setErrors([editTopic ? 'Ошибка обновления темы. Попробуйте еще раз.' : 'Ошибка создания темы. Попробуйте еще раз.']);
            logger.error('Ошибка операции с темой:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h2>{editTopic ? 'Редактировать тему' : 'Создать новую тему'}</h2>
                    <button 
                        className={styles.closeButton}
                        onClick={onClose}
                        disabled={loading}
                    >
                        ×
                    </button>
                </div>

                <form onSubmit={handleSubmit} className={styles.modalForm}>
                    {errors.length > 0 && (
                        <div className={styles.errorMessages}>
                            {errors.map((error, index) => (
                                <p key={index} className={styles.errorMessage}>{error}</p>
                            ))}
                        </div>
                    )}

                    <div className={styles.formGroup}>
                        <label htmlFor="category_id">Категория*</label>
                        <select
                            id="category_id"
                            name="category_id"
                            value={formData.category_id}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Выберите категорию</option>
                            {categories.map(category => (
                                <option key={category.id} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={styles.formGroup}>
                        <label htmlFor="title">Заголовок темы*</label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            placeholder="Введите заголовок темы"
                            maxLength="200"
                            required
                        />
                        <small className={styles.charCounter}>
                            {formData.title.length}/200 символов
                        </small>
                    </div>

                    <div className={styles.formGroup}>
                        <label htmlFor="content">Содержание*</label>
                        <textarea
                            id="content"
                            name="content"
                            value={formData.content}
                            onChange={handleInputChange}
                            placeholder="Опишите ваш вопрос подробно..."
                            rows="8"
                            maxLength="5000"
                            required
                        />
                        <small className={styles.charCounter}>
                            {formData.content.length}/5000 символов
                        </small>
                    </div>

                    <div className={styles.modalActions}>
                        <button 
                            type="button" 
                            onClick={onClose}
                            className={styles.cancelButton}
                            disabled={loading}
                        >
                            Отмена
                        </button>
                        <button 
                            type="submit"
                            className={styles.submitButton}
                            disabled={loading}
                        >
                            {loading ? (editTopic ? 'Сохраняю...' : 'Создаю...') : (editTopic ? 'Сохранить изменения' : 'Создать тему')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateTopicModal;